export interface CookieConsentState {
  version: 1;
  analytics: boolean;
  savedAt: string;
}

export const COOKIE_CONSENT_KEY = "cookieConsent";

export type CookieConsentValue = CookieConsentState | "accepted" | null;

export const COOKIE_CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export const COOKIE_CONSENT_OPTIONS = {
  default: () => null as CookieConsentValue,
  maxAge: COOKIE_CONSENT_MAX_AGE_SECONDS,
  sameSite: "lax" as const,
  path: "/",
};

export function normalizeCookieConsent(
  value: CookieConsentValue | unknown,
): CookieConsentState | null {
  if (value === "accepted") {
    return {
      version: 1,
      analytics: true,
      savedAt: "",
    };
  }

  if (!value || typeof value !== "object") {
    return null;
  }

  const maybeConsent = value as Partial<CookieConsentState>;
  if (
    maybeConsent.version !== 1 ||
    typeof maybeConsent.analytics !== "boolean"
  ) {
    return null;
  }

  return {
    version: 1,
    analytics: maybeConsent.analytics,
    savedAt:
      typeof maybeConsent.savedAt === "string" ? maybeConsent.savedAt : "",
  };
}

export function createCookieConsentState(
  analytics: boolean,
): CookieConsentState {
  return {
    version: 1,
    analytics,
    savedAt: new Date().toISOString(),
  };
}
